module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-line.02bf0d93.png";